import React from 'react';
import Course from './Course';

// 54) Now we want to remove the HTMLCourses import from here. Do this then ((go to Courses.js))

// import { HTMLCourses } from '../../data/courses';

// const HTML = (props) => {
//   let courses = HTMLCourses.map((course) => {
//     return <Course title={course.title}
//                    desc={course.description}
//                    img={course.img_src}
//                    key={course.id} />
//   });
//   return (
//     <div>
//       <ul>
//         {courses}
//       </ul>
//     </div>
//   );
// }

// 51) Next we rename the HTML function to CourseContainer ...

// const CourseContainer = (props) => {
//   let courses = HTMLCourses.map((course) => {
//     return <Course title={course.title}
//                    desc={course.description}
//                    img={course.img_src}
//                    key={course.id} />
//   });
//   return (
//     <div>
//       <ul>
//         {courses}
//       </ul>
//     </div>
//   );
// }

// 60) Finally instead of mapping over HTMLCourses, CSSCourses, or JSCourses, we map over our new data property. See below then go to ((App.js))

const CourseContainer = (props) => {
  let courses = props.data.map((course) => {
    return <Course title={course.title}
                   desc={course.description}
                   img={course.img_src}
                   key={course.id} />
  });
  return (
    <div>
      <ul>
        {courses}
      </ul>
    </div>
  );
}

// 52) And we also need to change the export statement. Do this then go to ((Courses.js))

export default CourseContainer;



// WEBPACK FOOTER //
// ./src/components/courses/CourseContainer.js